import { Heading, Text, UnorderedList, ListItem } from '@chakra-ui/react';

import Page from '@inspire/ui/chakra/layout/Page';

import Layout from 'components/layout/Layout';

const ConditionsGeneralesPage = () => (
  <Page
    title="Conditions Génerales d'Utilisation du site « INSPIRE »"
    headingIsTitle
    withPanel
  >
    <Heading size="md" textAlign="center">
      VERSION EN VIGUEUR AU 1er JANVIER 2022
    </Heading>
    <Heading size="md" mt={8}>
      PREAMBULE
    </Heading>
    <Text>
      Les présentes CGU pourront être mises à jour périodiquement, étant entendu
      que les modifications seront automatiquement opposables dès leur mise en
      ligne.
    </Text>
    <Text>
      Les présentes CGU pourront également être résiliées, à tout moment et à sa
      seule discrétion, par l'association Article 1, propriétaire de la
      plateforme INSPIRE.
    </Text>
    <Heading size="md" mt={8}>
      Définitions
    </Heading>
    <Text>
      <b>« Compte INSPIRE » :</b> désigne l’espace personnel dédié (Lycéen,
      Éclaireur ou Équipes Pédagogiques), accessible au moyen d’Identifiants ;
    </Text>
    <Text>
      <b>« Identifiants » :</b> désigne l’ensemble composé du login (adresse
      email renseignée dans le formulaire d’inscription) et du mot de passe
      permettant d’accéder au Compte INSPIRE ;
    </Text>
    <Text>
      <b>« Utilisateur » :</b> désigne tout individu qui se créé un "Compte
      INSPIRE" ;
    </Text>
    <Text>
      <b>« Equipe INSPIRE » :</b> désigne les salariés de l’association Article
      1 dédiés au programme INSPIRE ;
    </Text>
    <Text>
      <b>« Equipes Pédagogiques » :</b> désigne les professionnels de
      l’éducation nationale ayant pour mission d’accompagner des lycéens dans
      leur orientation ;
    </Text>
    <Text>
      <b>« Lycéen(s) » :</b> désigne les lycéens inscrits sur INSPIRE qui sont
      âgés de 15 ans ou plus, sont en Première ou en Terminale et préparent un
      bac général, technologique ou professionnel ;
    </Text>
    <Heading size="md" mt={8}>
      Conditions d’accès à INSPIRE
    </Heading>
    <Heading size="sm" mt={4}>
      Modalités d’inscription à INSPIRE
    </Heading>
    <Text>
      L’inscription en tant que Lycéen, Éclaireur ou membre d’une Équipe
      Pédagogique sur INSPIRE se fait en complétant et en validant l’ensemble
      des informations requises dans le formulaire d’inscription en ligne. Une
      demande d’inscription ne pourra pas être prise en compte sur la base d’un
      formulaire d’inscription incomplet. Chaque utilisateur s’engage, lors de
      son inscription, à fournir des données exactes.
    </Text>
    <Text>
      Tout profil incomplet, s’il demeure incomplet après une première relance,
      sera supprimé par l'Équipe INSPIRE un mois après la première relance.
    </Text>
    <Text>
      Une fois la demande d’inscription validée, il est possible d'accéder à
      tout moment au Compte INSPIRE au moyen des Identifiants.
    </Text>
    <Text>
      Il est interdit de créer ou d'utiliser d’autres comptes que celui
      initialement créé, que ce soit sous sa propre identité ou celle d’un
      tiers.
    </Text>
    <Heading size="sm" mt={4}>
      Identifiants du Compte INSPIRE
    </Heading>
    <Text>
      Lors de l'inscription, le choix des Identifiants permettra d’accéder au
      Compte INSPIRE. Les Identifiants choisis sont personnels et confidentiels.
      Ils ne peuvent être changés que par l'utilisateur lui-même dans son Compte
      INSPIRE, de sa propre initiative ou de celle de l'Équipe INSPIRE.
    </Text>
    <Text>
      Chaque utilisateur est responsable de l’utilisation de ses Identifiants et
      s’engage à mettre tout en œuvre pour conserver secrets ses Identifiants et
      ne pas les divulguer à qui que ce soit, sous quelque forme que ce soit, et
      pour quelque raison que ce soit.
    </Text>
    <Text>
      Toute utilisation des Identifiants sera ainsi réputée faite par
      l'utilisateur, même en cas d’utilisation des Identifiants par des tiers,
      qu’elles soient frauduleuses ou non, et garantit l'association Article 1
      contre toute demande à ce titre.
    </Text>
    <Text>
      En cas de divulgation volontaire ou non ou d’usurpation de l’un des
      Identifiants, l'utilisateur doit, dans les plus brefs délais, les modifier
      via le Compte INSPIRE et demeure responsable en tout état de cause,
      jusqu’à changement des Identifiants, de toute conséquence dommageable de
      cette divulgation ou de cette usurpation. Il est précisé à ce titre
      qu’INSPIRE n’est pas responsable en cas d’usurpation de l'identité d'un
      utilisateur ou de celle d’un tiers.
    </Text>
    <Text>
      Chaque utilisateur doit également informer l'Équipe INSPIRE immédiatement
      dès lors qu'il y a des raisons de penser qu’une personne utilise
      frauduleusement ses Identifiants et/ou accède frauduleusement à son Compte
      INSPIRE.
    </Text>
    <Heading size="md" mt={8}>
      Propriété Intellectuelle
    </Heading>
    <Text>
      L'association Article 1 est le titulaire exclusif ou le licencié de tous
      les éléments de propriété intellectuelle composant INSPIRE, tels que les
      logos, les marques, les dessins et modèles, les textes, images, fichiers,
      les technologies et le savoir-faire. Plus généralement, tous les droits de
      propriété intellectuelle, afférents au contenu et aux éléments
      d’information d’INSPIRE appartiennent en propre à l'association Article 1,
      ses partenaires et/ou ses concédants de licence.
    </Text>
    <Text>
      Sauf dérogation expresse et écrite, les droits qui sont conférés en vue de
      l’utilisation d’INSPIRE fournis par l'association Article 1 n’emportent
      aucune cession ni aucune autorisation d’exploiter l’un quelconque des
      éléments d’INSPIRE.
    </Text>
    <Text>
      Chaque utilisateur s’engage ainsi à faire usage des éléments figurant sur
      INSPIRE dans le strict respect des droits de propriété intellectuelle de
      l'association Article 1, ses partenaires et concédants de licence, et dans
      les strictes limites d’usage autorisées sur INSPIRE au travers de ses
      fonctionnalités mises à disposition.
    </Text>
    <Text>
      Chaque utilisateur est informé et reconnaît que tout contournement des
      fonctionnalités aux fins de détourner les usages permis sur INSPIRE et de
      manière générale, toute atteinte à ces droits de propriété intellectuelle
      constitue un acte de contrefaçon répréhensible tant civilement que
      pénalement.
    </Text>
    <Heading size="md" mt={8}>
      Limitation de responsabilité
    </Heading>
    <Heading size="sm" mt={4}>
      Fonctionnement et accessibilité à INSPIRE
    </Heading>
    <Text>
      L'association Article 1 a une simple obligation de moyens dans la mise à
      disposition du site INSPIRE et se dégage ainsi de toute responsabilité
      pour toute indisponibilité, suspension ou interruption du site INSPIRE ou
      simplement du Compte INSPIRE qui peuvent survenir dans le cadre
      d’opérations de maintenance, de mise à niveau du matériel ou logiciel, de
      réparations d’urgence ou par suite de circonstances indépendantes de sa
      volonté.
    </Text>
    <Text>
      Chaque utilisateur déclare accepter les caractéristiques et les limites
      techniques d’un service en ligne, et en particulier reconnaît :
    </Text>
    <UnorderedList>
      <ListItem>
        avoir connaissance des aléas de la consultation en ligne, en particulier
        au regard des temps de réponse ; qu’il lui appartient de prendre, ou
        demander aux responsables légaux de prendre, toutes mesures nécessaires
        pour assurer que les caractéristiques techniques de l'outil (ordinateur,
        téléphone, tablette…) utilisé permettent l’accès à INSPIRE ;
      </ListItem>
      <ListItem>
        être seul responsable de ses accès sur Internet et qu’il lui appartient
        de prendre toutes les mesures appropriées de façon à protéger ses
        propres données et/ou logiciels de la contamination par d'éventuels
        virus circulant sur Internet.
      </ListItem>
    </UnorderedList>
    <Text>
      Il appartient aux utilisateurs mineurs de faire appel aux parents (ou au
      titulaire de la responsabilité parentale) en cas de besoin concernant les
      points techniques ci-dessus.
    </Text>
    <Text>
      L'association Article 1 ne saurait être tenue pour responsable d’un non
      fonctionnement, d’une impossibilité d’accès, ou de mauvaises conditions
      d’utilisation d’INSPIRE imputables à un équipement non adapté, à des
      dysfonctionnements internes au fournisseur d’accès ou en cas de mauvaise
      utilisation d’INSPIRE.
    </Text>
    <Text>
      En tout état de cause, chaque utilisateur reconnaît expressément et
      accepte d’utiliser INSPIRE à ses propres risques et sous sa responsabilité
      exclusive.
    </Text>
    <Text>
      Il est également précisé que la présence de liens hypertexte sur INSPIRE
      vers des sites internet de tiers ne constitue pas une validation par
      l'association Article 1 de ces sites et de leur contenu. La responsabilité
      de l'association Article 1 ne saurait en conséquence être engagée à raison
      de contenus tiers, dont la responsabilité incombe à leur éditeur.
    </Text>
    <Heading size="sm" mt={4}>
      Risques liés à l’utilisation d’Internet
    </Heading>
    <Text>
      Chaque utilisateur reconnaît que les caractéristiques et les contraintes
      d’Internet ne permettent pas de garantir la sécurité, la disponibilité et
      l’intégrité des transmissions de données durant leur circulation sur
      Internet. Chaque utilisateur les communique donc à ses risques et périls.
      l'association Article 1 ne pourra être tenue responsable des incidents qui
      pourraient découler de cette transmission.
    </Text>
    <Text>
      Compte tenu des spécificités du réseau Internet, l'association Article 1
      n’offre aucune garantie de continuité du service, n’étant tenue à cet
      égard que d’une obligation de moyens.
    </Text>
    <Text>
      L’utilisation d’un algorithme afin d’obtenir des suggestions de Pistes
      d'études
    </Text>
    <Text>
      En tant que Lycéen, des "Pistes recommandées" sont proposées après analyse
      par un algorithme des informations fournies dans le questionnaire pour
      Lycéens.
    </Text>
    <Text>
      Ces recommandations ne constituent pas une opinion, un avis, ni un
      conseil, et sont fournies à titre indicatif et informationnel. Elles ne
      sauraient se substituer à l’avis d’un professionnel. Ainsi, le choix de
      filière demeure personnel et INSPIRE ne saurait voir sa responsabilité
      engagée pour quelque cause et sur quelque fondement que ce soit en
      relation avec les Pistes recommandées ainsi qu’aux choix exercés en
      conséquence.
    </Text>
    <Heading size="md" mt={8}>
      Protection des données à caractère personnel
    </Heading>
    Article 1 a désigné un Délégué à la Protection des données personnelles qui
    peut être contacté à alexandre.nguyen-van-ho@article-1.eu.
    <Heading size="sm" mt={4}>
      Données récoltées
    </Heading>
    <Text>
      Lors de l'inscription sur INSPIRE, l'association Article 1 est amenée à
      recueillir les données à caractère personnel suivantes :
    </Text>
    <UnorderedList>
      <ListItem>
        pour les Lycéens : prénom, nom, date de naissance, genre, adresse,
        email, niveau scolaire, lycée.
      </ListItem>
      <ListItem>
        Pour les Équipes Pédagogiques : titre de civilité, prénom, nom, adresse
        email professionnelle, lycée.
      </ListItem>
    </UnorderedList>
    <Text>
      Le caractère obligatoire ou facultatif des données personnelles demandées
      et les éventuelles conséquences d’un défaut de réponse sont précisés lors
      de leur collecte.
    </Text>
    <Text>
      Les informations et coordonnées personnelles collectées dans le cadre de
      la création d'un profil INSPIRE permettront à l'association Article 1, le
      cas échéant, de :
    </Text>
    <UnorderedList>
      <ListItem>
        mieux comprendre les freins des Lycéens concernant leur choix
        d’orientation afin de mieux cibler les actions du programme INSPIRE à
        l’avenir ;
      </ListItem>
      <ListItem>évaluer l’impact du programme</ListItem>
      <ListItem>
        proposer l’accès aux autres programmes proposés par l’association
        Article 1 ;
      </ListItem>
      <ListItem>
        proposer aux Équipes pédagogiques de contribuer au développement
        d’INSPIRE (tests utilisateurs, identification des besoins…).
      </ListItem>
    </UnorderedList>
    <Text>Aucun utilisateur ne sera nommé individuellement lors :</Text>
    <UnorderedList>
      <ListItem>
        des analyses de données internes à l'association Article 1,
      </ListItem>
      <ListItem>
        des communications sur l’impact du programme auprès des financeurs de
        l'association Article 1,
      </ListItem>

      <ListItem>d’éventuelles publications d’articles de recherche.</ListItem>
    </UnorderedList>
    <Text>
      Les données collectées seront réservées à l’usage exclusif de
      l'association Article 1 pour les seuls besoins de fonctionnement
      d’INSPIRE. Afin de permettre à l’équipe de faire des comparaisons
      pluriannuelles de l’impact du programme, les données seront stockées par
      l'association Article 1 pendant 10 ans sur des serveurs hébergés en
      Europe. Au-delà de cette date, elles seront effacées.
    </Text>
    <Text>
      Chaque utilisateur est informé que pour les besoins de l’exploitation
      d’INSPIRE ou pour répondre à des obligations légales ou réglementaires,
      les données sont communiquées à un sous-traitant situé en dehors de
      l’Union Européenne et notamment aux Etats-Unis. Toutefois, ce transfert
      est encadré par l’accord entre l’Union européenne et les Etats Unis, le
      Privacy Shield, qui offre une protection essentiellement équivalente aux
      exigences européennes au regard de la protection des données à caractère
      personnel.
    </Text>
    <Text>
      Conformément à la loi n°78-17 du 6 janvier 1978 relative à l'informatique,
      aux fichiers et aux libertés telle que modifiée (« loi Informatique et
      Libertés »), ainsi qu’au nouveau règlement européen 2016/679 du Parlement
      européen et du Conseil qui sera applicable à compter du 25 mai 2018, et
      toute loi et règlement qui pourrait les succéder, l’ensemble des données
      collectées peut donner lieu à l’exercice du droit d’accès, de
      rectification et d’opposition pour motifs légitimes, ou donner lieu à des
      instructions sur le sort des données suite à un décès les conditions et
      limites prévues par les articles 38, 39 et 40 de la loi Informatique et
      Libertés.
    </Text>
    <Text>
      A cet effet, chaque utilisateur peut obtenir une copie des données à
      caractère personnel le concernant et procéder à leur rectification en
      adressant un email à l’adresse suivante : contact@inspire-orientation.org
    </Text>
    <Text>
      Les traitements de données réalisés ont fait l'objet d'une déclaration
      auprès de la Commission Nationale de l'Informatique et des Libertés
      (CNIL).
    </Text>
    <Heading size="sm" mt={4}>
      Cookies
    </Heading>
    <Text>
      Un cookie est un petit fichier texte sauvegardé sur l'ordinateur de
      l'utilisateur ou son appareil mobile puis récupéré lors de ses visites
      ultérieures. Article 1 utilise des cookies pour que la visite de
      l'utilisateur soit plus simple et agréable. Article 1 n'utilise pas les
      cookies pour conserver des informations personnelles ni pour divulguer des
      informations à des tiers.
    </Text>
    <Text>
      Article utilise des cookies nécessaires au fonctionnement du service et
      permettant la navigation de l'utilisateur sur le site Internet ainsi que
      des cookies de mesure d'audience et analytiques afin d'identifier d'où
      viennent les utilisateurs et établir des statistiques de fréquentations
      anonymes.
    </Text>
    <Text>
      Certaines fonctionnalités de ce site Internet s’appuient sur des services
      proposés par des sites tiers. Ces fonctionnalités déposent des cookies
      permettant notamment à ces sites de tracer votre navigation, et à Article
      1 d'améliorer l'expérience des utilisateurs et les services proposés en
      continu.
    </Text>
    <Text>
      Notre site Internet utilise des cookies Crisp, l’outil de messagerie
      instantané que nous utilisons pour venir en aide aux utilisateurs sur
      l’utilisation du site en mettant l’utilisateur directement en contact avec
      les gérants du site travaillant au sein de Article 1. Les informations
      collectées par les cookies Crisp seront transmises et hébergées par Crisp
      sur des serveurs situés en Europe conformément à leur politique de
      confidentialité. Pour une présentation de la politique de confidentialité
      de Crisp, visitez https://crisp.chat/fr/privacy/
    </Text>
    <Text>
      Notre site Internet utilise des cookies Google Analytics. Les informations
      collectées par les cookies Google Analytics seront transmises et hébergées
      par Google sur des serveurs situés aux Etats-Unis d’Amérique conformément
      à leur politique de confidentialité. Pour une présentation de la politique
      de confidentialité de Google et savoir comment cela s’applique à Google
      Analytics, visitez http://www.google.com/intl/fr/policies/.
    </Text>
    <Text>
      Notre site Internet utilise des cookies Hotjar. Les informations
      collectées par les cookies Hotjar seront transmises et hébergées par
      Hotjar sur des serveurs situés En Europe conformément à leur politique de
      confidentialité. Pour une présentation de la politique de confidentialité
      de Hotjar et savoir comment cela s’applique à Hotjar, visitez
      https://www.hotjar.com/legal/policies/privacy/.
    </Text>
    <Text>
      Vous pouvez désactiver les cookies en modifiant les paramètres de votre
      navigateur vous permettant ainsi de refuser l’installation de tout ou
      partie des cookies. Cependant, si vous désactivez tous les cookies par le
      biais des paramètres de votre navigateur (notamment les cookies
      strictement nécessaires au fonctionnement), il est probable que vous ne
      puissiez plus avoir accès à tout ou partie des sites. Désactiver un cookie
      ou une catégorie de cookies ne les supprime pas de votre navigateur, la
      suppression nécessitant une action spécifique.
    </Text>
    <Text>
      Si vous souhaitez modifier les paramètres des cookies, veuillez aller dans
      les menus « Options » ou « Préférences » de votre navigateur. Pour plus
      d’informations, rendez-vous dans l’option « Aide » de votre navigateur.
    </Text>
    <Text overflow="hidden" wordBreak="break-word">
      Pour Chrome : https://support.google.com/chrome/answer/95647?hl=fr&hlrm=en
    </Text>
    <Text overflow="hidden" wordBreak="break-word">
      Pour Internet Explorer :
      http://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-Cookies
    </Text>
    <Text overflow="hidden" wordBreak="break-word">
      Pour FireFox :
      http://support.mozilla.org/fr/kb/cookies-informations-sitesenregistrent?redirectlocale=fr&redirectslug=G%C3%A9rer+les+cookies
    </Text>
    <Text>Pour Safari : http://support.apple.com/kb/PH11952</Text>
    <Text>
      Pour Opera : http://help.opera.com/Windows/12.10/fr/notrack.html
    </Text>
    <Text overflow="hidden">
      Pour Edge :
      https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy
    </Text>
    <Text>
      Vous pouvez également vous désengager du suivi de Google Analytics en
      visitant https://tools.google.com/dlpage/gaoptout?hl=fr
    </Text>
    <Text>
      Si vous avez désactivé un ou plusieurs cookies d’analyse, sachez que nous
      pouvons toujours utiliser les informations collectées par les cookies
      installés antérieurement à la désactivation, cependant nous arrêterons
      d’utiliser les cookies désactivés pour collecter d’autres informations.
    </Text>
    <Heading size="md" mt={8}>
      Autres dispositions
    </Heading>
    <Heading size="sm" mt={4}>
      Correspondance et preuve
    </Heading>
    <Text>
      En application des articles 1316 et suivants du Code civil, chaque
      utilisateur reconnaît et accepte, ainsi que son représentant légal, le cas
      échéant, que les informations délivrées par l'association Article 1 par
      courrier électronique et sur INSPIRE, et ce inclus les données figurant
      dans le Compte INSPIRE reçoivent la même force probante qu’un écrit
      manuscrit.
    </Text>
    <Heading size="sm" mt={4}>
      Notifications
    </Heading>
    <Text>
      Sauf stipulation expresse contraire, les notifications entre l'association
      Article 1 et l'utilisateur sont faites par e-mail. Les notifications sont
      réputées être parvenues 24 heures après l’envoi de l’email, sauf si
      l’expéditeur se voit notifier l’invalidité de l’adresse email.
    </Text>
    <Heading size="sm" mt={4}>
      Indépendance des dispositions contractuelles
    </Heading>
    <Text>
      Si l’une quelconque des stipulations des présentes est tenue pour nulle ou
      sans objet, elle sera réputée non écrite et n’entraînera pas la nullité
      des autres stipulations.
    </Text>
    <Text>
      Si une ou plusieurs stipulations des présentes deviennent caduques ou sont
      déclarées comme telles en application d’une loi, d’un règlement ou à la
      suite d’une décision définitive rendue par une juridiction compétente, les
      autres stipulations conserveront leur force obligatoire et leur portée.
      Les stipulations déclarées nulles et non valides seront alors remplacées
      par les stipulations qui se rapprocheront le plus quant à leur sens et à
      leur portée des stipulations initialement convenues.
    </Text>
    <Heading size="sm" mt={4}>
      Cession
    </Heading>
    <Text>
      L'association Article 1 se réserve le droit de céder à tout tiers de son
      choix tout ou partie de ses droits et obligations au titre des présentes
      CGU ou de se substituer tout tiers pour l’exécution des présentes, ce que
      chaque Lycéen ou Eclaireur accepte sans réserve.
    </Text>
    <Heading size="md" mt={8}>
      Loi applicable – Résolution des litiges
    </Heading>
    <Text>
      De convention expresse entre les parties, les présentes CGU et les
      opérations qui en découlent sont régies par le droit français. Elles sont
      rédigées en langue française exclusivement.
    </Text>
    <Text>
      En cas de difficulté ou de différend entre les parties à l’occasion de
      l’interprétation, de l’exécution ou de la résiliation des présentes CGU,
      les parties doivent s’employer à la résoudre au mieux et conviennent de
      rechercher une solution amiable dans l’esprit des présentes CGU. A défaut
      de solution amiable, la partie la plus diligente saisira les Tribunaux
      compétents.
    </Text>
  </Page>
);

ConditionsGeneralesPage.getWrappers = (page) => (
  <Layout
    variant="adaptative"
    rowProps={{ variant: 'gray' }}
    containerWidth="lg"
  >
    {page}
  </Layout>
);

export default ConditionsGeneralesPage;
